import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import * as Cookies from "js-cookie";

Vue.use(Vuex);

export default new Vuex.Store({
  strict: false,
  state: {
    user: null,
    token: null,
    isUserLoggedIn: false,
    tempArray: [],
    data: null,
    userData: {
      text: {
        subRegex:
          "(^.{50,100000}[，，、,.「」。。？；：！](?!$))(.{50,105000}$)",
        characterDelete: "「」",
        countCharacterDivide: 50,
        splitContentBy: "。."
      },
      voice: {
        voice: null,
        name: null,
        voiceData: {
          _id: null,
          speed: 100,
          volume: 100,
          pitch: 100,
          feeling: 2,
          noteVibes_pitch: 0,
          noteVibes_speed: 1,
          noteVibes_sayAs: null,
          noteVibes_volume: null,
          noteVibes_emphasis: null,
          noteVibes_pauses: null,
          advance: {
            speed: 1,
            volume: 1,
            pitch: 1
          }
        }
      }
    },
    isShowSlideBarLeft: null,
    isLoading: false,
    listVideo: [],
    totalPageVideo: 0,
    totalVideo: 0
  },
  mutations: {
    setTotalPageVideo(state, data) {
      state.totalPageVideo = data;
    },
    setTotalVideo(state, data) {
      state.totalVideo = data;
    },
    setListVideo(state, data) {
      state.listVideo = data || [];
      if (!data) {
        state.totalPageVideo = 0;
        state.totalVideo = 0;
      }
    },
    addNewVideo(state, data) {
      let checkExist = false;
      if (state.listVideo) {
        state.listVideo = state.listVideo.map(item => {
          if (item._id === data._id) {
            checkExist = true;
            return {
              ...item,
              ...data
            };
          }
          return item;
        });
        if (!checkExist) {
          state.listVideo.unshift(data);
          if (state.listVideo.length > 30) state.listVideo.pop();
        }
      }
    },
    updateAVideo(state, data) {
      if (state.listVideo) {
        state.listVideo = state.listVideo.map(item => {
          if (item._id === data._id) {
            return {
              ...item,
              ...data
            };
          }
          return item;
        });
      }
    },
    deleteVideoById(state, idVideo) {
      state.listVideo = state.listVideo.filter(item => item._id !== idVideo);
    },
    setLoading(state, data) {
      state.isLoading = data;
    },
    updateProfileRender(state, data) {
      state.data.listProfile = data;
    },
    deleteChannelUpload(state, idChannel) {
      let listChannel = state.data.listChannelUpload;
      listChannel = listChannel.filter(item => {
        if (item._id === idChannel) {
          return false;
        }
        return true;
      });
      state.data.listChannelUpload = listChannel;
    },
    updateItemChannelUpload(state, data) {
      let listChannel = state.data.listChannelUpload;
      let finded = false;
      listChannel = listChannel.map(item => {
        if (item._id === data._id) {
          finded = true;
          return data;
        }
        return item;
      });
      if (!finded) {
        listChannel.push(data);
      }
      state.data.listChannelUpload = listChannel;
    },
    setUser(state, user) {
      state.user = user;
      if (user) {
        state.token = user.token;
        state.isUserLoggedIn = true;
      } else {
        state.listVideo = null;
        state.totalPageVideo = null;
        state.totalVideo = null;
        state.token = null;
        state.isUserLoggedIn = false;
      }
    },
    pushTempArray(state, item) {
      state.tempArray.push(item);
    },
    updateTempArray(state, list) {
      state.tempArray = list;
    },
    updateItemTempArray(state, obj) {
      let _tempArray = state.tempArray;
      let index = _tempArray.findIndex(it => it.id == obj.id);
      if (index != -1) {
        _tempArray[index] = { id: obj.id, value: obj.value, type: obj.type };
      }
      state.tempArray = [];
      state.tempArray = _tempArray;

      state.tempArray.unshift({ id: 1 });
      state.tempArray.shift();
    },
    deleteItemTempArray(state, obj) {
      let index = state.tempArray.findIndex(it => it.id == obj.id);
      if (index != -1) {
        state.tempArray.splice(index, 1);
      }
    },
    setData(state, data) {
      let listLayout = data.listLayout;
      listLayout = listLayout.map((item, index) => {
        try {
          let data = JSON.parse(item.data);
          return {
            ...item,
            data
          };
        } catch (error) {
          return {
            ...item,
            data: null
          };
        }
      });
      data.listLayout = listLayout;
      state.data = data;
    },
    setListLayout(state, data) {
      state.data.listLayout = data;
    },
    setListChannelUpload(state, data) {
      state.data.listChannelUpload = data;
    },
    setListProfile(state, data) {
      state.data.listProfile = data;
    },
    setUserData_Text(state, data) {
      switch (data.type) {
        case "subRegex":
          state.userData.text.subRegex = data.value;
          break;
        case "characterDelete":
          state.userData.text.characterDelete = data.value;

          break;
        case "countCharacterDivide":
          state.userData.text.countCharacterDivide = data.value;
          break;
        case "splitContentBy":
          state.userData.text.splitContentBy = data.value;
          break;
      }
    },
    setUserData_Voice(state, data) {
      state.userData.voice = data;
    },
    updateListConfigVoice(state, data) {
      state.data.listVoiceConfig = data;
    },
    updateListFont(state, data) {
      state.data.listFont = data;
    },
    updateUserData(state, newData) {
      state.user = {
        ...state.user,
        ...newData
      }
    }
  },
  actions: {
    updateUserData({ commit }, data) {
      commit("updateUserData", data);
    },
    updateAVideo({ commit }, data) {
      commit("updateAVideo", data);
    },
    setTotalVideo({ commit }, data) {
      commit("setTotalVideo", data);
    },
    setTotalPageVideo({ commit }, data) {
      commit("setTotalPageVideo", data);
    },
    setListVideo({ commit }, data) {
      commit("setListVideo", data);
    },
    addNewVideo({ commit }, data) {
      commit("addNewVideo", data);
    },
    deleteVideoById({ commit }, data) {
      commit("deleteVideoById", data);
    },
    setLoading({ commit }, data) {
      commit("setLoading", data);
    },
    updateProfileRender({ commit }, data) {
      commit("updateProfileRender", data);
    },
    deleteChannelUpload({ commit }, data) {
      commit("deleteChannelUpload", data);
    },
    updateItemChannelUpload({ commit }, data) {
      commit("updateItemChannelUpload", data);
    },
    updateListFont({ commit }, data) {
      commit("updateListFont", data);
    },
    updateListConfigVoice({ commit }, data) {
      commit("updateListConfigVoice", data);
    },
    setUserData_Voice({ commit }, data) {
      commit("setUserData_Voice", data);
    },
    setUserData_Text({ commit }, data) {
      commit("setUserData_Text", data);
    },
    setListProfile({ commit }, data) {
      commit("setListProfile", data);
    },
    setListChannelUpload({ commit }, data) {
      commit("setListChannelUpload", data);
    },
    setListLayout({ commit }, data) {
      commit("setListLayout", data);
    },
    setData({ commit }, data) {
      commit("setData", data);
    },
    setUser({ commit }, user) {
      commit("setUser", user);
    },
    pushTempArray({ commit }, item) {
      commit("pushTempArray", item);
    },
    updateTempArray({ commit }, list) {
      commit("updateTempArray", list);
    },
    updateItemTempArray({ commit }, obj) {
      commit("updateItemTempArray", obj);
    },
    deleteItemTempArray({ commit }, obj) {
      commit("deleteItemTempArray", obj);
    }
  },
  getters: {
    userData: state => {
      return state.user;
    }
  },
  plugins: [
    createPersistedState({
      storeage: {
        getItem: key => Cookies.getJSON(key),
        setItem: (key, state) =>
          Cookies.set(key, state, { expires: 3, secure: true }),
        removeItem: key => Cookies.remove(key)
      }
    })
  ]
});



// WEBPACK FOOTER //
// ./src/store/store.js